module.exports = __webpack_public_path__ + "img/20190529162350381.28ff9ad6.png";